import { Price, Text } from '@kanda-libs/ks-design-library';
import type { Job } from '@kanda-libs/ks-frontend-services';
import Container from './Totals-container';

interface ViewComponentProps {
  /**
   * Kanda job object
   */
  job?: Job;
  /**
   * Kanda job object
   */
  isLoading?: boolean;
}

const ViewComponent = ({ job, isLoading }: ViewComponentProps) => (
  <Container job={job}>
    {({ total, deposit }) => (
      <>
        <div className="flex flex-col px-4 pt-4">
          <div className="flex flex-row justify-between">
            <div className="flex flex-row my-auto">
              <Text
                isLoading={isLoading}
                skeletonProps={{
                  width: 40,
                }}
                text="total"
                className="text-11-20-em-up text-neutral-600"
              />
              <Text
                isLoading={isLoading}
                skeletonProps={{
                  width: 60,
                }}
                text="incl. vat"
                className="ml-1 text-11-20-em-up text-neutral-500"
              />
            </div>
            <Price
              amount={total}
              isLoading={isLoading}
              color="neutral-900"
              poundsClassName="text-20-24-em"
              centsClassName="text-10-14-em mt-px"
            />
          </div>

          {deposit && (
            <div className="flex flex-row justify-between mt-2">
              <Text
                text="minimum deposit"
                className="my-auto text-11-20-em-up text-neutral-600"
                isLoading={isLoading}
                skeletonProps={{
                  width: 60,
                }}
              />
              <Price
                amount={deposit}
                color="neutral-600"
                poundsClassName="text-16-20-em"
                centsClassName="text-10-14-em mt-px"
                isLoading={isLoading}
              />
            </div>
          )}
        </div>
        <div className="mb-8 border-0 md:mt-8 md:mb-10 md:border-t border-neutral-300" />
      </>
    )}
  </Container>
);

ViewComponent.displayName = 'JobSidebar-Totals-view';

ViewComponent.defaultProps = {
  job: undefined,
  isLoading: false,
};

export default ViewComponent;
